module.exports = __webpack_public_path__ + "img/apl-10.b9b74118.jpg";